import { mockDataService } from './mockDataService';

export class AccountHistoryService {
  async getAccountHistory() {
    return await mockDataService.getAccountHistory();
  }
}
